import { clearStorages, clearCodeVerifier, clearOAuthState, getCodeVerifier, getOAuthState, setExpireTime, setToken, setTempToken, setUserData } from '../../utils/storage';
import { loginIdaman, loginUser, logoutUser } from '../../utils/api';
import { exchangeCodeForToken } from '../../utils/idaman';
import { FETCHED, LOADING } from './constants';

export function login(data, navigate) {
  return (dispatch) => {
    dispatch(loadingAction(true));
    loginUser(data)
      .then((res) => {
        dispatch(loadingAction(false));
        setTempToken(res.data.temporaryToken);
        setUserData({
          username: data.username,
          isMfaActive: res.data.isMfaActive,
        });
        const qrCountDown = new Date();
        qrCountDown.setMinutes(qrCountDown.getMinutes() + 60);
        if (res.data.isMfaActive) {
          navigate('/mfa/totp', { state: { qrCountDown } });
        } else {
          const btnCountDown = new Date();
          btnCountDown.setSeconds(btnCountDown.getSeconds() + 5);
          navigate('/mfa/connect-app', {
            state: { qrCountDown, btnCountDown },
          });
        }
      })
      .catch((err) => {
        const message =
          err.code >= 400 && err.code < 500
            ? err.message
            : 'Username atau password yang Anda masukan salah';
        dispatch(
          loginFetchedAction({
            code: err.code,
            message,
            username: data.username,
          })
        );
        dispatch(loadingAction(false));
      });
  };
}

export function logout() {
  return async (dispatch) => {
    dispatch(loadingAction(true));

    try {
      await logoutUser();
    } catch ({ message }) {
      dispatch(loginFetchedAction({ message }));
    } finally {
      clearStorages();
      location.href = '/dc/login';
    }
  };
}

function loadingAction(isLoading) {
  return { type: LOADING, isLoading };
}

function loginFetchedAction({ code = 0, message, username = '' }) {
  return { type: FETCHED, code, message, username };
}

export function clearError() {
  return async (dispatch) => {
    dispatch(loginFetchedAction({ message: '' }));
  };
}

export function loginOauthIdaman(code, urlState) {
  return async (dispatch) => {
    dispatch(loadingAction(true));

    const savedState = getOAuthState();
    if (!savedState || savedState !== urlState) {
      clearStorages();
      dispatch(loginFetchedAction({ code: 400, message: 'Autentikasi gagal: parameter state tidak valid.' }));
      dispatch(loadingAction(false));
      return;
    }

    try {
      const codeVerifier = getCodeVerifier();
      const idamanTokens = await exchangeCodeForToken(code, codeVerifier);
      const mapResponse = await loginIdaman(idamanTokens.access_token);

      const { accessToken, regional, adminId } = mapResponse.data;
      const { exp } = JSON.parse(atob(accessToken.split('.')[1]));
      setToken(accessToken);
      setExpireTime(exp);
      setUserData({ accessToken, regional, adminId });

      clearOAuthState();
      clearCodeVerifier();

      dispatch(loadingAction(false));
      const redirect = sessionStorage.getItem('redirect');
      if (redirect) {
        sessionStorage.removeItem('redirect');
        location.replace(redirect);
      } else {
        location.href = '/dc/authentication';
      }
    } catch (err) {
      clearStorages();
      let message;
      if (err?.status === 'NOT_REGISTERED') {
        message = 'Akun IdaMan tidak terdaftar.';
      } else if (err?.status === 'NOT_MATCH') {
        message = 'Akun IdaMan tidak sesuai.';
      } else {
        message = err?.message || 'Login dengan IdAMan gagal. Silahkan coba lagi.';
      }
      dispatch(loginFetchedAction({ code: err?.code || 500, message }));
      dispatch(loadingAction(false));
    }
  };
}
